import React from "react";

import { BookingFormRadioProps } from "shared/types";

import FormErrorText from "@components/UI/Form/FormErrorText";
import SimpleSelect, { FormControl } from "@components/UI/SimpleSelect";

export default function BookingFormRadio({
  value,
  onChange,
  options,
  isError,
  errorType,
  name,
}: BookingFormRadioProps) {
  const selectValue =
    options.length > 0 &&
    !!value &&
    options.find((option) => option.value === value);

  return (
    <>
      <SimpleSelect
        testId={`custom-select-${name}`}
        components={{ Control: FormControl }}
        value={selectValue}
        styles={{
          container: (base) => ({
            ...base,
            flexGrow: 1,
          }),
          valueContainer: (base) => ({
            ...base,
          }),
          placeholder: (base) => ({
            ...base,
          }),
        }}
        options={options}
        onChange={(changeValue) => onChange(changeValue.value)}
        isSearchable
      />

      {isError && (
        <div className="form-text-input-error">
          <FormErrorText error={errorType} />
        </div>
      )}
    </>
  );
}
